const userId = "044001";
const locationId = "1";

export { userId, locationId };